import React, { useRef } from 'react';

import { makeStyles } from '@styles/makeStyles';
import CloseIcon from '@mui/icons-material/Close';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import IconButton from '@components/IconButton';

import { useDraggable } from './draggable-hook';

const useStyles = makeStyles()(theme => ({
  root: {
    position: 'absolute',
    touchAction: 'none',
    left: 0,
    top: 0,
    minWidth: '200px',
    width: '75vw',
    maxWidth: '900px',
    minHeight: '350px',
    height: '75vh',
    maxHeight: '660px',
    flexDirection: 'column',
    zIndex: 1101,
    borderLeft: '1px solid #ccc',
    borderTop: '1px solid #ccc',
    boxShadow: '2px 2px 8px #ccc'
  },
  titleBar: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: theme.spacing(4.5),
    background: 'white',
    cursor: 'grab',
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  },
  dragIcon: {
    float: 'left',
    margin: theme.spacing(0.75),
    pointerEvents: 'none'
  },
  contentContainer: {
    width: '100%',
    flexGrow: 1,
    overflow: 'hidden'
  }
}));

const DraggableOverlay = ({
  visible,
  onClose,
  title,
  style = {},
  initialCoord = { x: 25, y: 115 }, // optional
  minY = 0, // optional
  onMove = () => {}, // optional
  className = '', // optional
  children
}) => {
  const { classes, cx } = useStyles();
  const titleBarRef = useRef();

  const { location } = useDraggable(titleBarRef, {
    initialCoord,
    onMove,
    minX: 0,
    minY
  });

  return (
    <div
      className={cx(classes.root, className)}
      style={{
        transform: `translate3d(${location.x}px, ${location.y}px, 0)`,
        display: visible ? 'flex' : 'none',
        ...style
      }}
    >
      <div ref={titleBarRef} className={classes.titleBar}>
        <DragIndicatorIcon className={classes.dragIcon} />
        <div style={{ flexGrow: 1, pointerEvents: 'none', userSelect: 'none' }}>
          {title}
        </div>
        <IconButton onClick={onClose} size="small" aria-label="close draggable overlay">
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.contentContainer}>{children}</div>
    </div>
  );
};

export default DraggableOverlay;
